export enum enteteTableauListeTraitementSGNFEnum {
	fichierDepose = 'Fichier intégré',
	type = 'Type',
	dateTraitement = 'Reçu le',
	statut = 'Statut',
	compteRendu = 'Compte-rendu',
	fichierGenere = 'Fichier produit',
}